module.exports = {
    common: {
        requestProcessFail: 'Ошибка обработки запроса',
        requestFail: 'Запрос не выполнен',
        networkError: 'Ошибка сети, повторите попытку позже',
        notFound: 'Адрес запроса не найден',
        serverError: 'Внутренняя ошибка сервера',
        selectCountry: 'Пожалуйста, выберите страну',
        confirmed: 'Подтверждено',
        cancelled: 'Отменено...',
        back: 'Назад',
    },

    homePage: {
        alreadyUse: 'Уже используется',
        remain: 'Осталось',
        search: 'Поиск',
        findIccid: 'Как найти ICCID',
        fillIccid: 'Ввести ICCID SIM-карты',
        fillIccid1: 'ICCID Number',
        changeLanguage: 'Сменить язык',
        confirm: 'Подтвердить',
        selectLanguage: 'Пожалуйста, выберите язык',
        selectImageFile: 'Пожалуйста, выберите файл изображения',
        processing: 'Обработка...',
        recognizeSuccess: 'Распознано успешно',
        recognizeFail: 'Не удалось распознать, попробуйте снова',
        recognizeEmpty: 'ICCID не распознан',
        compressFail: 'Сжатие не удалось',
        takePhoto: 'Сфотографировать',
        fromAlbum: 'Выбрать из альбома',
        recognizing: 'Распознавание...',
        openingCamera: 'Открытие камеры...',
        cameraFail: 'Не удалось открыть камеру',
        scanFail: 'Не удалось распознать. Наведите на QR-код',
    },
    planPage: {
        orderRecords: 'История заказов',
        contact: 'Аккаунт',
        expireNotify: 'При истечении тарифного плана просматривать изображение не получится.',
        dataUsed: 'Использовано',
        dataRemain: 'Остаток',
        planStatus: 'Статус',
        planAutoRenew: 'Подписаться',
        planOrders: 'Заказы',
        planCountry: 'Страна',
        planPackage: 'Тариф',
        realPakcage: '9.9 RUB/30 дней',
        autoRenewNotify: 'Автоматически снимается 9.9 RUB каждые 30 дней',
        goForPurchase: 'Далее к заказу',
        every: 'Автопродление на ',
        days: 'дней',
        lifetimeFreeFlow: 'Безлимит навсегда',
        renew: 'Руб. Можно отменить в любой момент',
        detail: 'Подробнее',
        nodata: 'Нет тарифного плана',
        autoRenewSaying: 'Уведомление об автопродлении',
        autoRenewSay1: 'Вы можете отключить автопродление в любое время. После отмены списания остановятся.',
        autoRenewSay2: 'Тарифы на трафик ниже при включенном автопополнении.',
        renewNoticeTitle: 'Важное уведомление',
        renewNotice1: 'Ваш тариф будет активирован сразу после успешной оплаты.',
        renewNotice2: 'Это подписка с автопродлением. Пожалуйста, ознакомьтесь с деталями перед покупкой.',
        agreePrefix: 'Продолжая, вы соглашаетесь с ',
        subscribePolicy: 'Политикой подписки',
        agreeMiddle: ' и ',
        refundPolicy: 'Политикой возврата',
        agreeSuffix: '.',
        close: 'Закрыть',
        subscription: 'Отменить подписку',
        cancelSubscription: 'Подтвердить отмену подписки?',
        conform: 'Подтвердить',
        cancel: 'Отмена',
        Unlimited:'Безлимитный',
        cardLeftTip: '360+180 Free',
        cardLeftTip270: '180+90 Free',
        purchaseTitle: 'Купить тариф'
    },
    couponRedeem: {
        title: 'Эксклюзивный купон на продление',
        titleNewbie: 'Эксклюзивный купон для новичков',
        subtitle: 'Спасибо, что вы с нами!',
        bullet1: 'Не более одного купона на ICCID',
        bullet2: 'Действителен до {date}',
        bullet3: 'Только один раз!',
        claimNow: 'Получить',
        goToUse: 'Использовать',
        receiveSuccess: 'Купон получен',
        receiveMissing: 'Некорректный купон или ICCID.',
        useToast: 'Используйте купон при оплате тарифа.',
        claimToast: 'Обратитесь в поддержку, чтобы завершить активацию купона.',
        empty: 'Нет доступных купонов',
        noCouponMsg: 'Нет купона',
        buyDirect: 'Купить сейчас',
        loading: 'Загрузка...',
    },
    payPage: {
        paymentConfirm: 'Подтверждение платежа',
        payContact: 'Контактный номер',
        payPackage: 'Тариф',
        payDuration: 'Длительность',
        payTotal: 'Сумма оплаты',
        paySelectPayment: 'Выбрать способ оплаты',
        payCard: 'Банковская карта',
        cardDesc: '',
        payCardBankCredit: 'Банковская карта / Кредит',
        cardSupportHint: 'Поддерживаются Visa, Mastercard, Apple Pay, Google Pay',
        currentSelected: 'Текущий выбор',
        autoBadge: 'Авто',
        subscribeCardDeduct: 'Подписка с банковской карты',
        subscribeEwalletDeduct: 'Подписка через электронный кошелёк',
        payOnceTitle: 'Разовый платёж',
        payOnceDesc: 'Разовая оплата без автопродления; один способ в строке.',
        rechargeEwalletDesc: 'Разовая оплата через кошелёк',
        rechargeQrisDesc: 'Оплата по QR-коду',
        rechargeBankDesc: 'Разовый банковский перевод',
        rechargeRetailDesc: 'Оплата в магазине',
        payEWallet: 'Электронный кошелек',
        payComfirm: 'Подтвердить платеж',
        paymentSecureHint: 'Ваша платёжная информация защищена и зашифрована.',
        inputContact: 'Пожалуйста, введите контактные данные.',
        contactAppNumber: 'Номер {app}',
        contactUpdateViaApp: 'Обновления заказа будут отправлены через {app}',
        contactPhonePlaceholder: 'Введите номер',
        contactPhoneMinLength: 'Введите не менее 8 цифр',
        orderCouponLoading: 'Загрузка купона...',
        couponAppliedSub: 'Применён к этому заказу',
        couponAvailableSub: 'Доступен для этого заказа',
        couponDeductLabel: 'Скидка по купону',
        amountAfterDeduction: 'Сумма после скидки',
        subscribeDetailTitle: 'Детали подписки (Автопродление)',
        subscribeDetailSubtitle: 'Просмотр периода оплаты, правил продления, отмены и др.',
        subscribeDetailIntro: 'Это подписка с автопродлением. Продолжая, вы соглашаетесь с условиями ниже.',
        subscribeBillingCycle: 'Период оплаты',
        subscribeBillingCycleVal: 'Каждые {days} дней',
        subscribeAmount: 'Сумма',
        subscribeAmountVal: '{amount} за {days} дней',
        subscribeNextRenewal: 'Следующее продление',
        subscribeNextRenewalVal: 'В день окончания срока сумма будет списана автоматически.',
        subscribePaymentMethod: 'Способ оплаты',
        subscribePaymentMethodVal: 'Будущие продления будут списываться с этого способа оплаты.',
        subscribeCancelAnytime: 'Отмена в любое время',
        subscribeCancelAnytimeVal: 'Вы можете отменить автопродление до следующей даты списания. После отмены тариф останется активным до истечения срока.',
        subscribeActivation: 'Активация',
        subscribeActivationVal: 'Ваш тариф будет активирован сразу после успешной оплаты.',
        refundSummaryTitle: 'Политика возврата (Кратко)',
        refundSummarySubtitle: 'Условия возврата, процесс и исключения',
        refundSummaryIntro: 'Возврат возможен только в следующих случаях:',
        refundSummaryCase1: 'Дублирующий платёж',
        refundSummaryCase2: 'Оплата прошла, но пакет не активирован',
        refundSummaryCase3: 'Технические проблемы, вызванные Franwell',
        refundSummaryDisclaimer: 'Возврат не предоставляется после успешной активации или частичного использования пакета.',
        refundSummaryLink: 'Полная политика возврата',
        agreeAutoRenew: 'Я понимаю, что это подписка с автопродлением, и соглашаюсь с условиями выше.',
        agreePoliciesPrefix: 'Я прочитал(а) и соглашаюсь с ',
        agreeAutoRenewRequired: 'Пожалуйста, подтвердите условия подписки с автопродлением.',
        agreePoliciesRequired: 'Пожалуйста, согласитесь с Политикой подписки и Политикой возврата.',
        agreeConsentRequired: 'Пожалуйста, отметьте поля согласия выше.',
        subscribePolicyPopupTitle: 'Политика подписки',
        subscribePolicySection1Title: '1. Подписка',
        subscribePolicyS1Item1: 'Ваша подписка начнётся сразу после успешной оплаты.',
        subscribePolicyS1Item2: 'Каждая подписка действует {days} дней.',
        subscribePolicyS1Item3: 'Ваша подписка будет автоматически продлеваться каждые {days} дней.',
        subscribePolicyS1Item4: 'Сумма продления — {amount} за {days} дней.',
        subscribePolicyS1Item5: 'Платежи за продление будут автоматически списываться с выбранного способа оплаты.',
        subscribePolicyS1Item6: 'Вы можете отменить автопродление в любое время до следующей даты списания.',
        subscribePolicyS1Item7: 'После отмены текущая подписка останется активной до истечения срока.',
        subscribePolicySection2Title: 'Руководство по отмене подписки',
        subscribePolicyS2Step1Label: 'Шаг 1',
        subscribePolicyS2Step1: 'Перейдите на страницу 4G',
        subscribePolicyS2Step2Label: 'Шаг 2',
        subscribePolicyS2Step2: 'Найдите кнопку подписки',
        subscribePolicyS2Step3Label: 'Шаг 3',
        subscribePolicyS2Step3: 'Нажмите «Отключить автопродление»',
        subscribePolicyS2Step4Label: 'Шаг 4',
        subscribePolicyS2Step4: 'Подтвердите отмену',
        subscribePolicyS2Tip: 'Вы можете продолжать пользоваться услугой до окончания текущего периода подписки.',
        subscribePolicyFullLink: 'Полная политика подписки',
        xenditSubscribeNoticeTitle: 'Важное уведомление',
        xenditSubscribeNotice1: 'Вы оформляете подписку с 29 по 31 число.',
        xenditSubscribeNotice2Prefix: 'Подписка будет успешно оформлена, но фактическое списание будет перенесено на ',
        xenditSubscribeNotice2Highlight: '1-й день следующего месяца.',
        xenditSubscribeNotice3: 'В этот период мы предоставим вам бесплатные дни использования. После списания оплаты срок действия вашего тарифа будет автоматически продлён.',
        xenditSubscribeNoticeConfirm: 'Понятно',
        refundPolicyPopupTitle: 'Политика возврата',
        refundPolicySection1Title: '1. Имеют право на возврат',
        refundPolicyS1Intro: 'Возврат предоставляется в следующих случаях:',
        refundPolicyS1Item1: 'Дублирующий платёж',
        refundPolicyS1Item2: 'Оплата прошла, но пакет не активирован',
        refundPolicyS1Item3: 'Технические проблемы, вызванные Franwell',
        refundPolicySection2Title: '2. Не имеют права на возврат',
        refundPolicyS2Intro: 'Возврат не предоставляется в следующих случаях:',
        refundPolicyS2Item1: 'SIM активирована и услуга передачи данных использована',
        refundPolicyS2Item2: 'Частичное или полное использование пакета',
        refundPolicyS2Item3: 'Передумали после покупки',
        refundPolicyS2Item4: 'Проблемы с покрытием сети или сигналом после успешной активации',
        refundPolicySection3Title: '3. Процесс возврата',
        refundPolicyS3Item1: 'Возврат будет обработан в течение 3-5 рабочих дней.',
        refundPolicyS3Item2: 'Средства будут возвращены на исходный способ оплаты.',
        selectPaymentRequired: 'Пожалуйста, выберите способ оплаты',
        paymentLinkInvalid: 'Недействительная ссылка для оплаты',
        redirectPaymentFailed: 'Не удалось открыть страницу оплаты. Пожалуйста, попробуйте вручную.',
        createOrderFailed: 'Не удалось создать заказ',
        creatingOrder: 'Создаем платеж…',
        paymentComponentLoadFailedRefresh: 'Не удалось загрузить платежный компонент. Обновите страницу.',
        paymentComponentLoadFailed: 'Не удалось загрузить платежный компонент',
        paymentFailed: 'Оплата не выполнена',
        paymentCancelled: 'Оплата отменена',
        paymentInitFailed: 'Ошибка инициализации оплаты',
        indonesiaPhoneInvalid: 'Неверный формат. Введите действительный номер в Индонезии',
    },
    paySuccessPage: {
        pendingResult: 'Результат ожидающего заказа',
        activationSuccess: 'Активация SIM-карты успешно отправлена',
        activationQuery: 'Проверить статус активации',
        pendingPaymentTitle: 'Ожидается оплата заказа',
        orderNoLabel: 'Номер заказа',
        redirectingPayment: 'Перенаправление на оплату...',
        pay: 'Оплата',
        orderNoMissing: 'Отсутствует номер заказа',
        paymentLinkInvalid: 'Недействительная ссылка для оплаты',
    },
    orderPage: {
        activated: 'Активировано',
        notActivated: 'Не активировано',
        closed: 'Закрыто',
        activateFailed: 'Активация не удалась',
        paySuccess: 'Успешно',
        payFailed: 'Не удалось',
        notPaid: 'Не оплачено',
        refunded: 'Возвращено',
        Pending: 'В ожидании',
        orderRecord: 'История заказов',
        orderStatus: 'Статус заказа',
        orderPayStatus: 'Статус оплаты',
        orderCountry: 'Страна',
        orderPackage: 'Тариф',
        orderIccid: 'ICCID',
        orderOrderTime: 'Время заказа',
        back: 'Назад'
    },
    deviceInfo: {
        title: 'Информация об устройстве',
        userId: 'ID ПОЛЬЗОВАТЕЛЯ',
        deviceId: 'ID УСТРОЙСТВА',
        operatorAlertTitle: 'Уведомление о разблокировке',
        operatorAlert: '' +
            'Это устройство получило официальную субсидию, благодаря чему предлагается по более выгодной цене и поставляется с официальной 4G SIM-картой для лучшего пользовательского опыта. Если вы хотите снять ограничения, вы можете разблокировать устройство за плату. После разблокировки вы сможете использовать другие совместимые SIM-карты.',
        unlockPermanent: 'Разблокировать навсегда',
        unlockDescription: 'Единоразовый платеж, постоянная разблокировка устройства',
        unlockDescription01: 'После разблокировки вы сможете использовать SIM-карту любого оператора.',
        unlockImmediate: 'Разблокировать сейчас',
        noticeTitle: 'Инструкция по разблокировке',
        unlockNotice: '' +
            'Напоминание: если вы уже оплатили, разблокировка вступит в силу через 5–10 минут. Пожалуйста, сохраняйте подключение к сети и попробуйте снова позже.'
    },
    deviceUnlockPaymentInfo: {
        title: 'Информация об устройстве',
        userId: 'ID ПОЛЬЗОВАТЕЛЯ',
        deviceId: 'ID УСТРОЙСТВА',
        total: 'Итого',
        paySelectPayment: 'Выберите способ оплаты',
        payCard: 'Банковская карта',
        payEWallet: 'Электронный кошелек',
        payConfirm: 'Подтвердить оплату',
        operatorAlert: '' +
            'Это устройство получило официальную субсидию, благодаря чему предлагается по более выгодной цене и поставляется с официальной 4G SIM-картой для лучшего пользовательского опыта. Если вы хотите снять ограничения, вы можете разблокировать устройство за плату. После разблокировки вы сможете использовать другие совместимые SIM-карты.',
        unlockPermanent: 'Разблокировать навсегда',
        unlockDescription: 'Единоразовый платеж, постоянная разблокировка устройства',
        unlockDescription01: 'После разблокировки вы сможете использовать SIM-карту любого оператора.',
        unlockImmediate: 'Разблокировать сейчас',
        noticeTitle: 'Инструкция по разблокировке',
        unlockNotice: '' +
            'Напоминание: если вы уже оплатили, разблокировка вступит в силу через 5–10 минут. Пожалуйста, сохраняйте подключение к сети и попробуйте снова позже.',
        unlockConfirm: "Подтвердить",
        unlockRequestFail: "Ошибка запроса",
        unlockTipsTitle: 'Советы',
        unlockedMsg: 'Это устройство уже разблокировано, повторная операция не требуется!',
        UnlockSuccessful: 'Поздравляем! Ваше устройство успешно разблокировано!'
    },
    feedbackPage: {
        title: 'Обратная связь',
        heroTitle: 'Расскажите, что произошло',
        heroSubtitle: 'Мы поможем вам как можно скорее.',
        ticketHistory: 'История моих обращений',
        problemCategory: 'Категория проблемы',
        issueSelectTitle: 'Выберите конкретную проблему',
        issueSelectSubtitle: 'Выберите вариант, который лучше всего соответствует вашей ситуации.',
        next: 'Далее',
        form: {
            describeTitle: 'Опишите вашу проблему',
            describeSubtitle: 'Пожалуйста, предоставьте больше деталей о возникшей проблеме.',
            describePlaceholder: 'Опишите вашу проблему здесь... (Макс. 500 символов)',
            uploadPhotoTitle: 'Загрузить фото (необязательно)',
            uploadPhotoSubtitle: 'Можно загрузить до 3 изображений',
            uploadScreenshotTitle: 'Загрузить скриншот (необязательно)',
            uploadScreenshotSubtitle: 'Помогает нам лучше понять проблему',
            contactEmailTitle: 'Контактный email',
            contactEmailPlaceholder: 'example@email.com',
            orderNoTitle: 'Номер заказа',
            orderNoPlaceholder: 'Пожалуйста, введите номер заказа',
            orderNoRequired: 'Пожалуйста, введите номер заказа',
            takePhoto: 'Сделать фото',
            chooseFromAlbum: 'Выбрать из альбома',
            cancel: 'Отмена',
            emailRequired: 'Пожалуйста, введите контактный email',
            emailInvalid: 'Пожалуйста, введите корректный email',
            describeRequired: 'Пожалуйста, опишите вашу проблему',
            uploading: 'Загрузка...',
            uploadFailed: 'Не удалось загрузить изображение, попробуйте снова',
            submitting: 'Отправка...',
            submitFailed: 'Не удалось отправить, попробуйте снова',
            confirmSelected: 'Вы выбрали:',
            pleaseMakeSure: 'Пожалуйста, убедитесь:',
            checkSimInserted: 'SIM-карта установлена правильно',
            checkDataPlanActive: 'Ваш тарифный план активен',
            checkCameraPowered: 'Камера включена',
            checkSignalStrength: 'Уровень сигнала не менее 2 делений',
            checkRestartCamera: 'Попробуйте перезапустить камеру',
            confirmPrompt: 'Пожалуйста, подтвердите перечисленные проблемы',
            submit: 'Отправить',
        },
        success: {
            title: 'Успешно отправлено!',
            subtitle: 'Наша служба поддержки получила ваш запрос.',
            ticketNumber: 'Номер обращения',
            submitTime: 'Время отправки',
            responseTime: 'Мы ответим вам в течение 24 часов (в рабочие дни).',
            statusCheck: 'Вы можете проверить статус в разделе «Мои обращения».',
            myTickets: 'Мои обращения',
            backToHome: 'На главную',
            copySuccess: 'Скопировано',
        },
        categories: {
            camera: { title: 'Камера', desc: 'Камера offline, нельзя смотреть, ночной режим' },
            sim: { title: 'SIM / Сеть', desc: 'Нет сети, слабый сигнал, проблема SIM' },
            recharge: { title: 'Пополнение / Тариф', desc: 'Пополнение не удалось, тариф не обновлен' },
            data: { title: 'Использование данных', desc: 'Высокий расход, неверный остаток данных' },
            device: { title: 'Функции устройства', desc: 'Детекция движения, облако, запись' },
            order: { title: 'Заказ и оплата', desc: 'Оплата не удалась, возврат, счет' },
            other: { title: 'Другое', desc: 'Другие проблемы' },
        },
        issues: {
            camera_offline: 'Камера offline',
            cannot_view_live: 'Нельзя смотреть live',
            playback_failed: 'Ошибка воспроизведения',
            night_vision: 'Проблема ночного режима',
            motion_detection: 'Детекция движения',
            camera_restart: 'Перезапуск камеры',
            camera_not_added: 'Камера не добавлена',
            sim_not_activated: 'SIM не активирована',
            no_network: 'Нет сети',
            weak_signal: 'Слабый сигнал',
            roaming_issue: 'Проблема роуминга',
            sim_replacement: 'Замена SIM',
            cannot_detect_sim: 'SIM не обнаружена',
            '4g_not_working': '4G не работает',
            recharge_failed: 'Пополнение не удалось',
            recharge_not_effective: 'Пополнение успешно, но не действует',
            plan_not_updated: 'Тариф не обновлен',
            wrong_package: 'Неверный пакет',
            auto_renewal: 'Автопродление',
            subscription: 'Подписка',
            refund: 'Возврат',
            coupon: 'Купон',
            high_data_usage: 'Высокий расход данных',
            data_used_too_fast: 'Данные расходуются слишком быстро',
            remaining_data_incorrect: 'Неверный остаток данных',
            usage_not_updated: 'Использование не обновлено',
            need_usage_report: 'Нужен отчет об использовании',
            payment_failed: 'Оплата не удалась',
            duplicate_payment: 'Дублирующая оплата',
            order_not_found: 'Заказ не найден',
            invoice: 'Счет',
            discount: 'Скидка',
            cloud_storage: 'Облачное хранилище',
            recording: 'Запись',
            sd_card: 'SD-карта',
            notification: 'Уведомление',
            firmware_upgrade: 'Обновление прошивки',
            device_binding: 'Привязка устройства',
            qr_code: 'QR-код',
            reset_device: 'Сброс устройства',
            other: 'Другое',
        },
        history: {
            tabs: {
                all: 'Все',
                processing: 'В обработке',
                waiting: 'Ожидание',
                resolved: 'Решено',
                closed: 'Закрыто',
            },
            status: {
                processing: 'В обработке',
                waiting: 'Ожидание',
                resolved: 'Решено',
                closed: 'Закрыто',
            },
            deviceId: 'ID устройства',
            iccid: 'ICCID',
            submitTime: 'Время отправки',
            empty: 'Обращений нет',
            loading: 'Загрузка...',
        },
    },

    PositiveReviewCashbackPopup:{
        title: 'Получите бесплатный интернет',
        tip:'за 5-звездочный отзыв',
        confirm: 'Получить сейчас'
    },

    newbieCouponPopup: {
        titleOffer: 'эксклюзивное предложение',
        noThreshold: 'Купон без условий',
        fullReduction: 'Купон на скидку от суммы',
        nonSubscribeOnly: 'Только для пакетов без подписки',
    }
}
